// LargeDetailTextBox.js
import React from 'react';
import './DetailBox.css'; // You can define shared styles here

const LargeDetailTextBox = ({ label, value }) => {
  return (
    <div className='large-detail-box'>
      <label className='detail-box-label fts-12 lt-gray'>{label}</label>
      <textarea 
        className='large-detail-textarea common-text fts-15 ftw-4' 
        value={value} 
        readOnly 
        rows={3} 
      />
    </div>
  );
};

export default LargeDetailTextBox;
